import * as React from "react";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import { ICellEditor } from "ag-grid-community";
import { RadioButton, RadioButtonGroup } from "material-ui";
import { NoAvailableOptions } from "./no-available-options";
import { KEYBOARD_KEYS } from "constants/keyboard";

export interface IChoiceValue {
    id: string;
    label: string;
    enabled: boolean;
}

export interface ISingleChoiceEditorProps {
    [key: string]: any;
    getAvailableValues: (stateChunk, itemFields) => IChoiceValue[];
    stateChunk?: any;
    onSelectedChoice?: (choice) => void;
}

interface IState {
    availableValues: IChoiceValue[];
    value: string;
}

export class SingleChoiceCellEditor
    extends React.PureComponent<ISingleChoiceEditorProps, IState>
    implements ICellEditor
{
    private styles = merge(
        {
            minWidth: "220px",
            overflow: "scroll",
            maxHeight: "400px",
            width: this.props.eGridCell?.style.width,
        },
        $(" .radioButton", { padding: "10px" })
    );

    constructor(props) {
        super(props);
        let value = props.value;
        const { eventKey, stateChunk } = this.props;

        if (eventKey === KEYBOARD_KEYS.BACKSPACE || eventKey === KEYBOARD_KEYS.DELETE) {
            value = "";
        }

        this.state = { value, availableValues: props.getAvailableValues(stateChunk, props.data) };
    }

    getValue() {
        return this.state.value;
    }

    isPopup(): boolean {
        return true;
    }

    handleRadioChange = (e) => {
        this.setState({ value: e.target.value });
        if (this.props.onSelectedChoice) {
            this.props.onSelectedChoice(e.target.value);
        }
        process.nextTick(() => this.props.api?.stopEditing());
    };

    render() {
        const { value, availableValues } = this.state;
        return (
            <div {...this.styles}>
                {availableValues.length ? (
                    <RadioButtonGroup
                        name="allocation-selector"
                        data-test={DATATEST.ASSORTMENTS.GRID.SINGLE_CHOICE_CELL_EDITOR}
                        valueSelected={value}
                        onChange={this.handleRadioChange}
                    >
                        {availableValues.map(
                            ({ id, label, enabled }) =>
                                enabled && <RadioButton className="radioButton" key={id} value={id} label={label} />
                        )}
                    </RadioButtonGroup>
                ) : (
                    <NoAvailableOptions />
                )}
            </div>
        );
    }
}
